import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { EvaluationRoutingModule } from './evaluation-routing.module';
import { ListEvaluationComponent } from './components/list-evaluation/list-evaluation.component';
import { TemplateEvaluationComponent } from './components/template-evaluation/template-evaluation.component';
import { AddQuestionComponent } from './components/add-question/add-question.component';
import { EsnEvaluationSentComponent } from './components/esn-evaluation-sent/esn-evaluation-sent.component';
import { PvEvaluationComponent } from './components/pv-evaluation/pv-evaluation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AddTemplateComponent } from './components/add-template/add-template.component';
import { DetailsEvalComponent } from './components/details-eval/details-eval.component';
import { ListeEvaluateursComponent } from './components/liste-evaluateurs/liste-evaluateurs.component';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { DetailsTemplateComponent } from './components/details-template/details-template.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EvalWegestuComponent } from './components/eval-wegestu/eval-wegestu.component';
import { DetailsEvalWegestuComponent } from './components/details-eval-wegestu/details-eval-wegestu.component';
import { DetailsEvalRecComponent } from './components/details-eval-rec/details-eval-rec.component';
import { RatingModule } from 'ngx-bootstrap/rating';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { DetailsPvComponent } from './components/pv-evaluation/details-pv/details-pv.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { QuillModule } from 'ngx-quill';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';
import { FieldErrorModule } from '@shared/components/shared-field-error/field-error.module';
import { SharedModule } from '@shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule,CdkDropList,CdkDrag } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
@NgModule({
  declarations: [
    ListEvaluationComponent,
    TemplateEvaluationComponent,
    AddQuestionComponent,
    EsnEvaluationSentComponent,
    PvEvaluationComponent,
    AddTemplateComponent,
    DetailsEvalComponent,
    ListeEvaluateursComponent,
    DetailsTemplateComponent,
    EvalWegestuComponent,
    DetailsEvalWegestuComponent,
    DetailsEvalRecComponent,
    DetailsPvComponent,
  ],
  imports: [
    CommonModule,
    EvaluationRoutingModule,
    NgSelectModule,
    PaginationModule,
    ReactiveFormsModule,
    FormsModule,
    RatingModule.forRoot(),
    AngularSignaturePadModule,
    NgxSpinnerModule,
    CalendarModule,
    FieldErrorModule,
    SharedModule,
    MatMenuModule,
    DragDropModule,
    CdkDropList,
    CdkDrag,
    MatExpansionModule,
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]

})
export class EvaluationModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
